import { jsPDF } from "jspdf";

const symbolFor = (cur) => (cur === "CAD" ? "CA$" : "$");
const money = (n, cur) => `${symbolFor(cur)}${Math.round(n || 0).toLocaleString("en-US")}`;

export const exportEstimatePDF = ({ request, result, name }) => {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const cur = result.currency || "USD";
  let y = 56;

  // Header bar
  doc.setFillColor(10, 37, 64);
  doc.rect(0, 0, W, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("cost2build.ai", 40, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(200, 215, 235);
  doc.text("AI Construction Cost Estimate", 40, 70);

  y = 130;
  doc.setTextColor(10, 37, 64);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(name || `${request.building_type || "Project"} Estimate`, 40, y);
  y += 20;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(90, 100, 115);
  const meta = `${request.building_type || ""} · ${request.size_sqft || ""} sq ft · ${request.finish_level || ""} · ${request.region || ""} · ${request.country || ""}`;
  doc.text(meta, 40, y);
  y += 24;

  // Total range box
  doc.setDrawColor(220, 38, 38);
  doc.setFillColor(248, 250, 252);
  doc.roundedRect(40, y, W - 80, 54, 6, 6, "FD");
  doc.setTextColor(10, 37, 64);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(`${money(result.total_low, cur)} - ${money(result.total_high, cur)}`, 56, y + 34);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(120, 130, 145);
  doc.text("Estimated total range", W - 56, y + 22, { align: "right" });
  doc.text(cur, W - 56, y + 36, { align: "right" });
  y += 78;

  // Summary
  if (result.summary) {
    doc.setFontSize(10);
    doc.setTextColor(60, 70, 85);
    const lines = doc.splitTextToSize(result.summary, W - 80);
    doc.text(lines, 40, y);
    y += lines.length * 13 + 12;
  }

  // Scopes table header
  doc.setFillColor(29, 78, 216);
  doc.rect(40, y, W - 80, 22, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("SCOPE OF WORK", 48, y + 15);
  doc.text("MATERIAL", W - 200, y + 15);
  doc.text("LABOR", W - 110, y + 15);
  doc.text("SUBTOTAL", W - 48, y + 15, { align: "right" });
  y += 22;

  doc.setFont("helvetica", "normal");
  doc.setTextColor(40, 50, 65);
  (result.scopes || []).forEach((s, i) => {
    if (y > 720) { doc.addPage(); y = 56; }
    if (i % 2 === 0) {
      doc.setFillColor(245, 248, 252);
      doc.rect(40, y, W - 80, 20, "F");
    }
    const sub = (s.material || 0) + (s.labor || 0);
    doc.setFontSize(9);
    doc.text(String(s.name || "").slice(0, 40), 48, y + 14);
    doc.text(money(s.material, cur), W - 200, y + 14);
    doc.text(money(s.labor, cur), W - 110, y + 14);
    doc.setFont("helvetica", "bold");
    doc.text(money(sub, cur), W - 48, y + 14, { align: "right" });
    doc.setFont("helvetica", "normal");
    y += 20;
  });

  y += 20;
  if (y > 700) { doc.addPage(); y = 56; }
  doc.setFontSize(8);
  doc.setTextColor(150, 158, 170);
  const disclaimer = "AI-generated ballpark estimate. Not a substitute for a licensed contractor quote. Prices vary by market conditions and scope.";
  doc.text(doc.splitTextToSize(disclaimer, W - 80), 40, y);

  const fname = (name || request.building_type || "cost2build-estimate").replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  doc.save(`${fname}.pdf`);
};
